import { useState, useEffect } from 'react';
import { DateTime } from 'luxon';

export const useCountdownToMonthEndUTC = () => {
  const [timeLeft, setTimeLeft] = useState<[number, number, number]>([0, 0, 0]);

  useEffect(() => {
    const calculateTimeLeft = (): [number, number, number] => {
      // Get current time in UTC timezone
      const now = DateTime.now().setZone('UTC');
      
      // Get end of current month in UTC timezone
      const endOfMonth = now.endOf('month');
      
      // Calculate difference
      const diff = endOfMonth.diff(now, ['days', 'hours', 'minutes']).toObject();
      
      // Round minutes to nearest integer
      const minutes = Math.round(diff.minutes || 0);
      
      // Return as tuple of [days, hours, minutes]
      return [
        Math.floor(diff.days || 0),
        Math.floor(diff.hours || 0),
        minutes
      ] as [number, number, number];
    };

    // Update immediately
    setTimeLeft(calculateTimeLeft());

    // Update every minute
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000); // 60000 ms = 1 minute

    return () => clearInterval(interval);
  }, []);

  return timeLeft;
}; 